<template>
    <div>
        <label class="control-label">{{ trans('giftcards.background') }}</label>
        <div class="grid gap-4 m-b-15" :class="[`grid-cols-${designsPerRow}`]">
            <div class="text-center"
                :class="[index === currentDesign ? 'opacity-100' : 'opacity-30']"
                v-for="index in styles"
                :key="index"
            >
                <a href="" class="block settings-gift-card" :class="'giftcard-color-' + index" @click.prevent="chooseDesign(index)"></a>
            </div>
            <div class="text-center" :class="[`col-start-${imageInputStartColumn}`, `col-end-${imageInputEndColumn}`]">
                <div :class="{ 'has-error' : errors.has('background_image') }">
                    <image-upload-input
                            enable-unsplash
                            unsplash-search-query="Gift Card"
                            :placeholder_text="trans('settings.giftcard.add_bg')"
                            @imageChange="updateBackgroundImage"
                            max_file_size="10M"
                            allowed_file_extensions="jpg png jpeg"
                            :default_file="currentImage"
                            :error_text="trans('settings.giftcard.add_bg_error')"
                    ></image-upload-input>

                    <span v-if="errors.has('background_image')" class="help-block">{{ errors.first('background_image') }}</span>

                </div>
            </div>
        </div>
        <label class="control-label">{{ trans('giftcards.text_color') }}</label>
        <color-picker
            disable-title
            :stored_color="textColor"
            @changeColor="changeColor"
            :trigger_style="{width: '100px', height: '38px'}"
            position="right"
        ></color-picker>
    </div>
</template>

<script>
import ImageUploadInput from 'Components/global/form/ImageUploadInput.vue';
import ColorPicker from 'Components/global/form/ColorPicker.vue';

export default {
    name: 'GiftcardDesignSelection',
    props: {
        currentImage: {
            default: '',
        },
        currentDesign: {
            type: Number,
            required: true,
        },
        designsPerRow: {
            type: Number,
            default: 4,
        },
        textColor: {
            type: String,
            required: true,
        },
    },
    emits: ['designUpdated'],
    data() {
        return {
            styles: 12,
        }
    },
    methods: {
        chooseDesign(designNumber) {
            this.$emit('design-updated', designNumber);
        },
        updateBackgroundImage(file) {
            this.$emit('image-updated', file);
        },
        changeColor(newTextColor) {
            this.$emit('text-color-updated', newTextColor);
        },
    },
    computed: {
        imageInputStartColumn() {
            return (this.styles % this.designsPerRow) + 1;
        },
        imageInputEndColumn() {
            return this.designsPerRow + 1;
        },
    },
    components: {
        ImageUploadInput,
        ColorPicker,
    },
}
</script>
